import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
    const navigate = useNavigate();

    return (
        <div className="bg-gray-50 min-h-screen py-10">
            <div className="mx-auto max-w-3xl bg-white p-6 md:p-12 shadow-sm rounded-2xl">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-8 flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
                >
                    <ArrowLeft size={16} />
                    Volver
                </button>
                <div className="text-gray-700 leading-relaxed text-sm md:text-base space-y-6">
                    <h1 className="text-3xl font-extrabold text-gray-900 mb-8">🛡️ Política de Privacidad</h1>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">1. Responsable del Tratamiento</h2>
                        <p>
                            El responsable del tratamiento de los datos recabados a través de esta aplicación es Zovy Solutions (en adelante, "la Plataforma"). Puedes contactar con nosotros para cualquier duda sobre privacidad en: [TU EMAIL DE CONTACTO].
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">2. ¿Qué datos recogemos y para qué?</h2>
                        <p className="mb-2">Recopilamos los datos estrictamente necesarios para que el programa de fidelización funcione:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li><strong>Datos de Registro:</strong> Nombre y correo electrónico (para crear tu cuenta y que puedas recuperar tu contraseña).</li>
                            <li><strong>Datos de Uso y Transacciones:</strong> Historial de puntos ganados, premios canjeados e importe de las compras asociadas. Esto sirve para mantener tu saldo actualizado y aplicar las políticas de caducidad.</li>
                            <li><strong>Comunicaciones (Email Marketing):</strong> Si un comercio tiene activa la caducidad de puntos, utilizaremos tu email para enviarte recordatorios automáticos (ej. "Tus puntos caducan en 7 días") para que no pierdas tus recompensas.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">3. ¿Con quién compartimos tus datos?</h2>
                        <p>
                            La Plataforma actúa como puente. Cuando te unes al programa de puntos de un comercio específico (Franquicia), ese comercio tiene acceso a tu nombre, saldo de puntos en su local y tu historial de transacciones con ellos, con el único fin de gestionar sus recompensas. No vendemos tus datos a terceros.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">4. Almacenamiento Técnico (Alternativa a Cookies)</h2>
                        <p>
                            Nuestra aplicación utiliza almacenamiento local seguro en tu dispositivo (localStorage) exclusivamente para guardar tu "token de sesión". Esto es estrictamente necesario para mantenerte conectado a tu cuenta de forma segura y no requiere consentimiento previo, al no usarse para rastreo publicitario.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">5. Tus Derechos (Derechos ARCO+)</h2>
                        <p>
                            Tienes derecho a acceder, rectificar, limitar, portar o solicitar la eliminación completa de tus datos en cualquier momento. Si borramos tu cuenta, perderás todos los puntos acumulados en todos los comercios. Para ejercer tus derechos, escríbenos a [TU EMAIL DE CONTACTO] desde el correo asociado a tu cuenta.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
